import { render, staticRenderFns } from "./addRoomPage.vue?vue&type=template&id=2795cb59&scoped=true&"
import script from "./addRoomPage.vue?vue&type=script&lang=js&"
export * from "./addRoomPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2795cb59",
  null
  
)

export default component.exports